import { render, staticRenderFns } from "./TheSidebarList.vue?vue&type=template&id=71a331a6"
import script from "./TheSidebarList.vue?vue&type=script&lang=ts"
export * from "./TheSidebarList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports